import { StateKey } from 'common/utils/flipState'
import { Filter, RelationProductType, SubVertical } from 'common/constants'
import { axios } from 'common/utils'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

export const initialState = false

const FETCH = '/relation-products/FETCH_RELATION_PRODUCTS'

export const fetchRelationProduct = (curState: StateKey, subVertical: SubVertical, storeId: string) => async (
  dispatch,
  getState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchRelationProductCount', { curState, storeId })
  if (isCacheHit(getState().store[curState], cacheParam)) {
    return
  }
  const params = {
    subVertical,
    storeId,
    filter: subVertical === SubVertical.DEPARTMENT ? Filter.DISPLAY : Filter.COORDI,
    relationProductType: subVertical === SubVertical.DEPARTMENT ? RelationProductType.VMD : RelationProductType.COORDI,
  }
  const result = await axios.get(`/v1/relation-products/${storeId}/count`, {
    params,
  })

  const hasRelationProduct = result && result.data

  dispatch({
    curState,
    hasRelationProduct,
    type: FETCH,
  })
}

const hasRelationProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return action.hasRelationProduct
    default:
      return state
  }
}

export default hasRelationProductReducer
